import { useContext } from "react";
import StepStart from "../../../components/StepStart/StepStart";
import { StepperContext } from "../../../contexts";
import { FinancialInformation } from "../../../assets/images";

const FinancialInformationStartScreen = () => {
  const { nextStep } = useContext(StepperContext);
  return (
    <StepStart
      title="Company financial information"
      subtitle="Last step, where we learn more about your company financials."
      image={FinancialInformation}
      onNext={() => {
        nextStep();
      }}
    />
  );
};

export default FinancialInformationStartScreen;
